import VerifyPayment from './VerifyPayment';
import compose from 'recompose/compose';
import withState from 'recompose/withState';
import lifecycle from 'recompose/lifecycle';
import formatPrismicData from '../../hocs/formatPrismicData';
import { withParams } from '../../hocs/router';
import { getOrderState } from 'src/common/facades/eagle/checkout';
import logger from 'src/logger';
import { getCookies } from '../../../facades/eagle/helpers/cookies';

const PAYMENT_FAILED_STATE = 'payment-failed-state';
const ORDER_COMPLETED_STATE = 'complete';
const STOP_POLLING_STATES = [ORDER_COMPLETED_STATE, PAYMENT_FAILED_STATE];

const pollPayment = async (orderNumber, retries, waitTime, handler) => {
  if (!orderNumber) {
    return handler(new Error('No order number found!'));
  }

  let error = null;
  let state = null;

  try {
    const response = await getOrderState(orderNumber, getCookies());
    state = response.body.state;
    if (state === PAYMENT_FAILED_STATE) {
      error = new Error(`Payment for order ${orderNumber} failed!`);
    }
  } catch (err) {
    switch (err.status) {
      case 404:
        error = new Error(`Order ${orderNumber} does not exist.`);
        retries = 0;
        break;
      case 401:
        error = new Error(`User is unauthorized to view order ${orderNumber}.`);
        retries = 0;
        break;
    }
  }

  if (!STOP_POLLING_STATES.includes(state) && retries > 0) {
    return setTimeout(() => pollPayment(orderNumber, --retries, waitTime, handler), waitTime);
  }

  handler(error);
};

const enhance = compose(
  formatPrismicData,
  withParams,
  withState('complete', 'setComplete'),
  lifecycle({
    async componentDidMount() {
      const props = this.props;
      if (!props.orderState) {
        try {
          const response = await getOrderState(props.params.orderNumber, getCookies());
          const state = response.body.state;
          props.setComplete(state === ORDER_COMPLETED_STATE);
        } catch (err) {
          props.setComplete(true);
        }
      }
    },
    async componentDidUpdate() {
      const props = this.props;
      if (!props.complete) {
        await pollPayment(props.params.orderNumber, 20, 1000, ((error) => {
          if (error) {
            logger.error(error);
            // todo: redirect somewhere
            props.setComplete(true);
            return;
          }
          props.setComplete(true);
        }));
      }
    }
  }),
);


export default enhance(VerifyPayment);



// WEBPACK FOOTER //
// ./src/client/js/view/components/VerifyPayment/index.js